import React from 'react';
import { ReactComponent as InfoIcon } from '../../assets/icons/info-icon.svg';
import { Button } from '../Button/Button';
import { KpiTableProps, KpiRow } from './types';
import styles from './KpiTableFactsMobile.module.scss';

function formatValue(value: number | null): string {
  if (value === null) return '—';
  return value.toLocaleString('ru-RU');
}

export function KpiTableFactsMobile({
  rows,
  editable,
  onKpiClick,
  onEdit,
  onDelete,
  onMethodologyClick
}: KpiTableProps) {
  return (
    <div className={styles.list}>
      {rows.map((row, index) => (
        <KpiCard
          key={row.id}
          row={row}
          index={index}
          editable={editable}
          onKpiClick={onKpiClick}
          onEdit={onEdit}
          onDelete={onDelete}
          onMethodologyClick={onMethodologyClick}
        />
      ))}
    </div>
  );
}

interface CardProps {
  row: KpiRow;
  index: number;
  editable?: boolean;
  onKpiClick?: (row: KpiRow) => void;
  onEdit?: (row: KpiRow) => void;
  onDelete?: (row: KpiRow) => void;
  onMethodologyClick?: (row: KpiRow) => void;
}

function KpiCard({ row, index, onKpiClick, onMethodologyClick }: CardProps) {
  const years = row.years.map((y) => y.year);

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <button className={styles.nameLink} onClick={() => onKpiClick?.(row)}>
          <span className={styles.nameIndex}>{index + 1}</span>
          {row.name}
        </button>
      </div>

      <div className={styles.meta}>
        <span className={styles.metaItem}>
          <span className={styles.metaLabel}>Ед. изм.</span>
          {row.unit}
        </span>
        <span className={styles.metaSpacer} />
        <span className={styles.metaItem}>
          <span className={styles.metaLabel}>Вес</span>
          {row.weight}
        </span>
        <button
          className={styles.methodLink}
          onClick={() => onMethodologyClick?.(row)}
        >
          Методика&nbsp; <InfoIcon className={styles.infoIcon} />
        </button>
      </div>

      {/*
        Планшет (540–1024px): строки = годы, колонки = план/факт
        Мобила (<540px):      строки = план/факт, колонки = годы
      */}
      <div className={styles.valuesGrid}>
        {/* Планшет: заголовок — пустая ячейка + "План" + "Факт, год" */}
        <div className={styles.tabletHeader}>
          <div className={styles.yearCell} />
          <div className={styles.planHeader}>План</div>
          <div className={styles.planFacts}>Факт, 6 мес</div>
          <div className={styles.planFacts}>Факт, 9 мес</div>
          <div className={styles.factHeader}>Факт, год</div>
        </div>

        {/* Планшет: строки по годам */}
        {row.years.map((y) => (
          <div key={y.year} className={styles.tabletRow}>
            <div className={styles.yearCell}>{y.year}</div>
            <div className={styles.planCell}>{formatValue(y.plan)}</div>
            <div className={styles.factCellMonth}>
              {formatValue(y.fact6months)}
            </div>
            <div className={styles.factCellMonth}>
              {formatValue(y.fact9months)}
            </div>
            <div className={styles.factCell}>{formatValue(y.fact)}</div>
          </div>
        ))}

        {/* Мобила: заголовок — пустая ячейка + годы */}
        <div className={styles.mobileHeader}>
          <div className={styles.mobileHeaderLabel} />
          {years.map((year) => (
            <div key={year} className={styles.mobileHeaderYear}>
              {year}
            </div>
          ))}
        </div>

        {/* Мобила: строка "План" */}
        <div className={styles.mobilePlanRow}>
          <div className={styles.mobilePlanLabel}>План</div>
          {row.years.map((y) => (
            <div key={y.year} className={styles.mobilePlanCell}>
              {formatValue(y.plan)}
            </div>
          ))}
        </div>
        <div className={styles.mobileFactMonthRow}>
          <div className={styles.mobileFactMonthLabel}>Факт, 6 мес</div>
          {row.years.map((y) => (
            <div key={y.year} className={styles.mobileFactCell}>
              {formatValue(y.fact6months)}
            </div>
          ))}
        </div>

        <div className={styles.mobileFactMonthRow}>
          <div className={styles.mobileFactMonthLabel}>Факт, 9 мес</div>
          {row.years.map((y) => (
            <div key={y.year} className={styles.mobileFactCell}>
              {formatValue(y.fact9months)}
            </div>
          ))}
        </div>

        {/* Мобила: строка "Факт, год" */}
        <div className={styles.mobileFactRow}>
          <div className={styles.mobileFactLabel}>Факт, год</div>
          {row.years.map((y) => (
            <div key={y.year} className={styles.mobileFactCell}>
              {formatValue(y.fact)}
            </div>
          ))}
        </div>
      </div>

      <div className={styles.dept}>
        <span className={styles.deptLabel}>Оценивающее подразделение:</span>
        <span className={styles.deptValue}>{row.department}</span>
      </div>
      <Button variant={'secondary'} onClick={() => alert('Оспорить')}>
        Оспорить
      </Button>
    </div>
  );
}
